
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket/live-score/upcoming",
      function () {
        return require("private-next-pages/cricket/live-score/upcoming/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket/live-score/upcoming"])
      });
    }
  